<template>
    <div id="options-change-notifications">
        <h3>Notificaciones</h3>
        <p>
            Aquí podrá seleccionar qué tipos de correos electrónicos recibirá cuando esté asociado a uno o más sitios web.
        </p>

        <b-form
            @submit.stop.prevent="onSubmit"
            class="mt-4"
        >
            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <b-form-group id="input-group-notifications">
                            <b-form-checkbox
                                v-model="notifications.notice"
                                name="notice"
                                :value="1"
                                :unchecked-value="0"
                                size="lg"
                                switch
                                :disabled="formDisabled"
                            >
                                Noticias
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="notifications.file"
                                name="file"
                                :value="1"
                                :unchecked-value="0"
                                size="lg"
                                switch
                                :disabled="formDisabled"
                            >
                                Descargas/Vídeos
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="notifications.forum"
                                name="forum"
                                :value="1"
                                :unchecked-value="0"
                                size="lg"
                                switch
                                :disabled="formDisabled"
                            >
                                Foros
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="notifications.comment"
                                name="comment"
                                :value="1"
                                :unchecked-value="0"
                                size="lg"
                                switch
                                :disabled="formDisabled"
                            >
                                Comentarios
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="notifications.assignment"
                                name="assignment"
                                :value="1"
                                :unchecked-value="0"
                                size="lg"
                                switch
                                :disabled="formDisabled"
                            >
                                Entregas
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="notifications.evaluation"
                                name="evaluation"
                                :value="1"
                                :unchecked-value="0"
                                size="lg"
                                switch
                                :disabled="formDisabled"
                            >
                                Evaluaciones
                            </b-form-checkbox>
                    </b-form-group>

                </b-col>
            </b-row>
            <div class="text-center float-right">
                <b-button
                    type="submit"
                    variant="primary"
                    size="lg"
                    :disabled="formDisabled || !notificationsChanged"
                >
                    Cambiar
                </b-button>
            </div>
        </b-form>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'SettingsChangeNotifications',
    data () {
        return {
            formDisabled: false,
            notifications: {
                notice: 1,
                file: 1,
                forum: 1,
                comment: 1,
                assignment: 1,
                evaluation: 1,
                events: 1
            }
        }
    },
    computed: {
        ...mapGetters([
            'getUserEmailPreferences'
        ]),
        notificationsChanged () {
            if (this.getSettingsNumber(this.notifications) === this.$store.state.userData.emailSettings) {
                return false
            }
            return true
        }
    },
    watch: {
        getUserEmailPreferences (val) {
            this.updateNotifications(val)
        }
    },
    methods: {
        ...mapActions([
            'changeCurrentUserNotifications'
        ]),
        updateNotifications (newPreferences) {
            this.notifications.notice = newPreferences.notice
            this.notifications.file = newPreferences.file
            this.notifications.forum = newPreferences.forum
            this.notifications.comment = newPreferences.comment
            this.notifications.assignment = newPreferences.assignment
            this.notifications.evaluation = newPreferences.evaluation
            this.notifications.events = newPreferences.events
        },
        getSettingsNumber (emailSettings) {
            return parseInt(
                `${emailSettings.events}${emailSettings.evaluation}${emailSettings.assignment}` +
                `${emailSettings.comment}${emailSettings.forum}${emailSettings.file}${emailSettings.notice}`,
                2
            )
        },
        async onSubmit () {
            const prefs = this.notifications
            const newEmailSettings = this.getSettingsNumber(prefs)
            try {
                this.formDisabled = true
                await this.changeCurrentUserNotifications(newEmailSettings)
                this.$root.successToast('Sus notificaciones han sido cambiadas satisfactoriamente.', 'Notificaciones Actualizadas')
            } catch (err) {
                console.log(err)
                this.unknownErrorToast()
            } finally {
                this.formDisabled = false
            }
        }
    },
    beforeMount () {
        this.updateNotifications(this.getUserEmailPreferences)
    }
}
</script>
